import ElevareMark from "./ElevareMark";

/**
 * Full stacked brand lockup — the E monogram above the "ELEVARE" wordmark with
 * "SOLUTIONS" spaced beneath it, exactly matching the brand banner. Used on the
 * footer and the admin login screen for a stronger brand moment.
 */
export default function ElevareLockup({ markSize = 64, className = "", align = "center" }) {
  const alignCls = align === "left" ? "items-start text-left" : "items-center text-center";
  return (
    <div data-testid="elevare-lockup" className={`flex flex-col ${alignCls} ${className}`}>
      <ElevareMark size={markSize} />
      <div className="mt-3 leading-none">
        <div className="font-head font-bold tracking-[0.14em] text-[#1e3d3a]" style={{ fontSize: markSize * 0.42 }}>
          ELEVARE
        </div>
        <div
          className="mt-1.5 uppercase text-[#c9a961] font-medium"
          style={{ fontSize: markSize * 0.16, letterSpacing: `${markSize * 0.055}px` }}
        >
          Solutions
        </div>
      </div>
    </div>
  );
}
